import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  Alert,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { invalidIds } from "../../../utility";
import { Autocomplete } from "@mui/material";
import FunctionsIcon from "@mui/icons-material/Functions";
import { DERIVED_TO_DATA_ENTRY_HISTORY_MESSAGE } from "../../../constants/parameterMessages";


const DefinitionPopup = ({
  open,
  onClose,
  formData,
  errors,
  onChange,
  handleSubmit,
  sepcificaitonForm,
  fieldType,
  setFieldType,
  handleAcceptanceValueChange,
  handleDeleteAcceptanceValue,
  handleAddAcceptanceValue,
  handleBlockChange,
  handleDeleteBlock,
  handleAddBlock,
  parameter,
  limitOperation,
  handleSaveAsDraft,
  addTargetData,
  dropdownOption,
  setFormulaOpen,
  formulaOpen,
  formulaDisplayValue,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [originalParameterType, setOriginalParameterType] = React.useState({
    parameterId: "",
    type: "",
  });


  const [selectedClass, setSelectedClass] = React.useState(formData?.parameter_class || "");
  const [newClass, setNewClass] = React.useState("");
  const [classError, setClassError] = React.useState("");
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setIsEdit(false);
    onClose();
  };


  const [selectedUom, setSelectedUom] = React.useState(formData?.unit_of_measure || "");
  const [newUom, setNewUom] = React.useState("");
  const [uomError, setUomError] = React.useState("");

  useEffect(() => {
    const uomList = dropdownOption?.metaList?.data?.unit_of_measure || [];
    const currentUom = formData?.unit_of_measure || "";

    const exists = uomList.some((item) => item.name === currentUom);

    if (exists) {
      setSelectedUom(currentUom);
      setNewUom("");
    } else {
      setSelectedUom("");
      setNewUom(currentUom);
    }

    const classList = dropdownOption?.metaList?.data?.parameter_classes || [];
    const currentClass = formData?.parameter_class || "";

    const classExists = classList.some((item) => item.name === currentClass);

    if (classExists) {
      setSelectedClass(currentClass);
      setNewClass("");
    } else {
      setSelectedClass("");
      setNewClass(currentClass);
    }

  }, [open, formData, dropdownOption]);

  useEffect(() => {
    if (!open || !formData?.parameter_id) {
      setOriginalParameterType({ parameterId: "", type: "" });
      return;
    }

    setOriginalParameterType((current) => (
      String(current.parameterId) === String(formData.parameter_id)
        ? current
        : {
            parameterId: formData.parameter_id,
            type: formData.source_system || "",
          }
    ));
  }, [open, formData?.parameter_id, formData?.source_system]);

  const isDerived = formData?.source_system === "Derived";
  const isDerivedToDataEntry =
    Boolean(formData?.parameter_id) &&
    originalParameterType.type === "Derived" &&
    formData?.source_system === "Data Entry";
  const unitOperations = dropdownOption?.metaList?.data?.unit_operations || [];
  const selectedUnitOperation = unitOperations.find(
    (item) => String(item.id) === String(formData?.unit_op_id)
  ) || (formData?.parameter_id && formData?.unit_op_id && formData?.unit_op_name
    ? {
        id: formData.unit_op_id,
        name: formData.unit_op_name,
        product_name: formData.product_name,
        site_name: formData.site_name,
      }
    : null);

  const getUnitOperationLabel = (option) => {
    const context = [option?.product_name, option?.site_name]
      .filter(Boolean)
      .join("-");

    return context ? `${option?.name} ( ${context} )` : option?.name || "";
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted={false}
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 5,
          m: 0,
          width: isEdit ? 400 : 500,
          maxHeight: "calc(100% - 160px)",
          height: "100%",
          boxShadow: "none",
          elevation: 0,
          border: "1px solid #ccc",
          p: 1,
          transition: "width 0.3s ease",
        },
      }}
    >
      <>
        {" "}
        <>
          <DialogTitle className="dialog-title">
            <Label
              text={formData.parameter_id ? "Update Parameter" : "Add Parameter"}
              color="#fff"
              fontSize="14px"
              fontWeight="500"
            ></Label>

            <BackButtons onClick={handleClose} />
          </DialogTitle>

          <DialogContent sx={{ padding: 0.5 }}>
            {/* UNIT OPERATION DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Unit Operation *" />

              <Autocomplete
                size="small"
                disabled={Boolean(formData?.parameter_id)}
                options={unitOperations}
                getOptionLabel={getUnitOperationLabel}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id) === String(value?.id)
                }
                value={selectedUnitOperation}
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "unit_op_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search Unit Operation"
                    error={!!errors?.unit_op_id}
                    helperText={errors?.unit_op_id}
                  />
                )}
              />
            </Box>

            {/* PHASE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Phase" />

              <Autocomplete
                size="small"
                options={dropdownOption?.metaList?.data?.phases || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  dropdownOption?.metaList?.data?.phases?.find(
                    (item) => item.name === formData?.phase_name
                  ) || null
                }
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "phase_name",
                      value: newValue?.name || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Search Phase" />
                )}
              />
            </Box>

            {/* TABLE LEVEL DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Table" />

              <Autocomplete
                size="small"
                disabled={isDerived}
                options={dropdownOption?.metaList?.data?.tables || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  dropdownOption?.metaList?.data?.tables?.find(
                    (item) => item.name === formData?.table_level_name
                  ) || null
                }
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "table_level_name",
                      value: newValue?.name || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Search Table" />
                )}
              />
            </Box>



            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Name *" />
              <TextField
                name="parameter_name"
                fullWidth
                size="small"
                value={formData?.parameter_name}
                onChange={onChange}
                error={!!errors?.parameter_name}
                helperText={errors?.parameter_name}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Description" />
              <TextField
                name="description"
                fullWidth
                size="small"
                disabled
                value={formData?.description}
                onChange={onChange}
                error={!!errors?.description}
                helperText={errors?.description}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Notes" />
              <TextField
                name="notes"
                fullWidth
                size="small"
                disabled
                value={formData?.notes}
                onChange={onChange}
                error={!!errors?.notes}
                helperText={errors?.notes}
              />
            </Box>



            {/* DATATYPE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Data Mandatory" />
              <TextField
                select
                name="is_required"
                fullWidth
                size="small"
                value={formData?.is_required}
                onChange={onChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>


            {/* SOURCE SYSTEM DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Type *" />
              <TextField
                select
                name="source_system"
                fullWidth
                size="small"
                value={formData?.source_system}
                onChange={onChange}
                error={!!errors?.source_system}
                helperText={errors?.source_system}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Data Entry">Data Entry</MenuItem>
                <MenuItem
                  value="Derived"
                  disabled={Boolean(formData?.parameter_id) && originalParameterType.type === "Data Entry"}
                >
                  Derived
                </MenuItem>
              </TextField>
              {isDerivedToDataEntry && (
                <Alert severity="warning" sx={{ mt: 0.5 }}>
                  {DERIVED_TO_DATA_ENTRY_HISTORY_MESSAGE}
                </Alert>
              )}
            </Box>

           
              {formData?.source_system === "Derived" && (
                <Box
                  onClick={() => setFormulaOpen(true)}
                  sx={{
                    mt: 2,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                    px: 2,
                    py: 2,

                    borderRadius: "8px",

                    border: errors?.formula ? "1px solid #d32f2f" : "1px solid #D0D5DD",
                    backgroundColor: "#F9FAFB",

                    cursor: false ? "not-allowed" : "pointer",

                    transition: "all 0.2s ease",

                    opacity: false ? 0.5 : 1,

                    "&:hover": {
                      backgroundColor: "#EEF2FF",
                      borderColor: "#6366F1",
                      boxShadow: "0 0 0 3px rgba(99,102,241,0.15)",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  {/* ICON BOX (left square like UI tools) */}
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "6px",
                      backgroundColor: "#6366F1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FunctionsIcon sx={{ fontSize: 16, color: "#fff" }} />
                  </Box>

                  {/* TEXT */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#344054",
                        lineHeight: 1.2,
                      }}
                    >
                      Open Formula Builder *
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "#667085",
                      }}
                    >
                      {formulaDisplayValue || "Build derived parameter formula"}
                    </Typography>
                  </Box>
                </Box>
              )}
              {formData?.source_system === "Derived" && errors?.formula && (
                <Typography sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5, ml: 1.75 }}>
                  {errors.formula}
                </Typography>
              )}
            {/* UNIT OF MEASURE (Custom Entry Allowed) */}
            {/* UNIT OF MEASURE */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Unit of Measure (UoM)" />

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                {/* Dropdown */}
                <Autocomplete
                  size="small"
                  fullWidth
                  options={dropdownOption?.metaList?.data?.unit_of_measure || []}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    dropdownOption?.metaList?.data?.unit_of_measure?.find(
                      (item) => item.name === selectedUom
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue?.name || "";

                    setSelectedUom(value);
                    setNewUom("");
                    setUomError("");

                    onChange({
                      target: {
                        name: "unit_of_measure",
                        value: value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search UOM"
                      error={!!uomError}
                      helperText={uomError}
                    />
                  )}
                />

                {/* Custom Entry */}
                <TextField
                  size="small"
                  fullWidth
                  name="unit_of_measure"
                  placeholder="Enter New UOM"
                  value={newUom}
                  error={!!uomError}
                  helperText={uomError}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    setSelectedUom("");
                    setNewUom(value);
                    const exists = dropdownOption?.metaList?.data?.unit_of_measure.some(
                      (item) => item.name === value
                    );
                    if (exists) {
                      setUomError("Unit already exists");
                    } else {
                      setUomError("");
                      onChange({
                        target: {
                          name: "unit_of_measure",
                          value: value,
                        },
                      });
                    }
                  }}
                />
              </Box>
            </Box>


            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Class" />

              <Box sx={{ display: "flex", gap: 1 }}>

                {/* Dropdown */}
                <Autocomplete
                  size="small"
                  fullWidth
                  options={dropdownOption?.metaList?.data?.parameter_classes || []}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    dropdownOption?.metaList?.data?.parameter_classes?.find(
                      (item) => item.name === selectedClass
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue?.name || "";

                    setSelectedClass(value);
                    setNewClass("");
                    setClassError("");

                    onChange({
                      target: {
                        name: "parameter_class",
                        value: value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Class"
                      error={!!classError}
                      helperText={classError}
                    />
                  )}
                />

                {/* Custom Entry */}
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Enter New Class"
                  value={newClass}
                  name="parameter_class"
                  error={!!classError}
                  helperText={classError}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    setSelectedClass("");
                    setNewClass(value);

                    // 🔥 Duplicate Check (case insensitive)
                    const exists = dropdownOption?.metaList?.data?.parameter_classes?.some(
                      (item) => item.name === value
                    );

                    if (exists) {
                      setClassError("Class already exists");
                    } else {
                      setClassError("");
                      onChange({
                        target: {
                          name: "parameter_class",
                          value: value,
                        },
                      });
                    }
                  }}
                />
              </Box>
            </Box>
            {/* DATATYPE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Data Type*" />
              <TextField
                select={!isDerived}
                name="data_type"
                fullWidth
                size="small"
                value={isDerived ? "Numeric" : (formData?.data_type || "")}
                onChange={onChange}
                error={!!errors?.data_type}
                helperText={errors?.data_type}
                InputProps={isDerived ? { readOnly: true } : undefined}
              >
                {!isDerived && <MenuItem value="">Select</MenuItem>}
                {!isDerived && <MenuItem value="text">Text</MenuItem>}
                {!isDerived && <MenuItem value="numeric">Numeric</MenuItem>}
                {!isDerived && <MenuItem value="date">Date</MenuItem>}
              </TextField>
            </Box>

          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: 1,
              borderTop: "1px solid #ccc",
            }}
          >
            <Buttons
              size="small"
              text={formData.parameter_id ? "Update" : "Submit"}
              onClick={handleSubmit}
              loading={dropdownOption?.addPara?.loading || dropdownOption?.updatePara?.loading}
            />
            {/* <Buttons
              size="small"
              text="Save Draft"
              onClick={handleSaveAsDraft}
              loading={limitOperation?.draftLoader}
            /> */}
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={onClose}
            />
          </DialogActions>
        </>
      </>
    </Dialog>
  );
};

export default DefinitionPopup;
